import React from 'react'

import { BrandIconProps } from '../types'
import { SmallSVG } from '../small-svg'

export const AppleIcon = ({ size, small }: BrandIconProps) => (
  <SmallSVG
    size={size}
    small={small}
    viewBox="0 0 42 120"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="apple-logo" fill="#fff" transform="translate(0.000000, 35.000000)" fillRule="nonzero">
        <path
          d="M41.2,39 C40.4,40.8 39.6,42.4 38.6,43.8 C37.2,45.8 36,47.2 35.2,48 C33.8,49.2 32.4,50 30.8,50 C29.6,50 28.2,49.6 26.6,49 C25,48.4 23.4,48 22,48 C20.6,48 19,48.4 17.4,49 C15.8,49.6 14.4,50 13.4,50 C11.8,50 10.4,49.4 8.8,48 C7.8,47.2 6.6,45.8 5.2,43.6 C3.6,41.4 2.4,38.8 1.4,36 C0.6,33 0,30 0,27 C0,23.6 0.8,20.8 2.2,18.4 C3.4,16.4 4.8,15 6.8,13.8 C8.8,12.6 10.6,12 12.8,12 C14,12 15.6,12.4 17.6,13.2 C19.6,14 20.8,14.4 21.4,14.4 C21.8,14.4 23.2,14 25.6,13 C27.8,12.2 29.8,11.8 31.2,12 C35.4,12.4 38.6,14 40.6,17 C36.8,19.2 35,22.4 35,26.6 C35,29.8 36.2,32.4 38.4,34.6 C39.4,35.6 40.6,36.4 41.8,36.8 C41.8,37.4 41.6,38.2 41.2,39 L41.2,39 Z M31.6,1 C31.6,3.6 30.6,5.8 28.8,8 C26.6,10.6 24,12 21,11.8 C21,11.6 21,11.2 21,10.8 C21,8.4 22,5.8 24,3.8 C25,2.8 26.2,1.8 27.6,1.2 C29,0.6 30.4,0.2 31.6,0 C31.6,0.4 31.6,0.6 31.6,1 L31.6,1 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </SmallSVG>
)

AppleIcon.defaultProps = {
  size: {
    width: 42,
    height: 120,
  },
}
